module.exports = {
    tag: 'life',
    quality: 0.4,
    mana: 1,
    strength: 1,
    regeneration: 1.2
};